import {UnderlineNav} from '@primer/react'
import {Link} from '@github-ui/react-router'

import {RUNNERS_FOCUS_TARGET_ATTRIBUTE} from './components/RunnersError'
import {GitHubHostedRunners} from './components/GitHubHostedRunners'
import {SelfHostedRunners} from './components/SelfHostedRunners'
import type {GitHubHostedRunnersResponse, RunnersQueryState, SelfHostedRunnersData} from './types'
import styles from './RepositoryRunners.module.css'

export interface RepositoryRunnersProps {
  selectedTab: 'github-hosted' | 'self-hosted'
  githubHostedRunnersPath: string
  selfHostedRunnersPath: string
  fetchRunnersBasePath: string
  setUpRunnersLink?: string
  softNavigationEnabled?: boolean
  /** Caller-owned data for the selected tab. When omitted, the tab fetches its runners on mount. */
  runnersState?: RunnersQueryState<GitHubHostedRunnersResponse | SelfHostedRunnersData>
}

export function RepositoryRunners({
  selectedTab,
  githubHostedRunnersPath,
  selfHostedRunnersPath,
  fetchRunnersBasePath,
  setUpRunnersLink,
  softNavigationEnabled = false,
  runnersState,
}: RepositoryRunnersProps) {
  return (
    <>
      <UnderlineNav aria-label="Runner type" className={styles.TabNav}>
        {softNavigationEnabled ? (
          <>
            <UnderlineNav.Item
              as={Link}
              to={githubHostedRunnersPath}
              aria-current={selectedTab === 'github-hosted' ? 'page' : undefined}
            >
              GitHub-hosted runners
            </UnderlineNav.Item>
            <UnderlineNav.Item
              as={Link}
              to={selfHostedRunnersPath}
              aria-current={selectedTab === 'self-hosted' ? 'page' : undefined}
            >
              Self-hosted runners
            </UnderlineNav.Item>
          </>
        ) : (
          <>
            <UnderlineNav.Item
              href={githubHostedRunnersPath}
              aria-current={selectedTab === 'github-hosted' ? 'page' : undefined}
            >
              GitHub-hosted runners
            </UnderlineNav.Item>
            <UnderlineNav.Item
              href={selfHostedRunnersPath}
              aria-current={selectedTab === 'self-hosted' ? 'page' : undefined}
            >
              Self-hosted runners
            </UnderlineNav.Item>
          </>
        )}
      </UnderlineNav>
      <div
        role="region"
        aria-label={selectedTab === 'github-hosted' ? 'GitHub-hosted runners' : 'Self-hosted runners'}
        tabIndex={-1}
        {...{[RUNNERS_FOCUS_TARGET_ATTRIBUTE]: ''}}
      >
        {selectedTab === 'github-hosted' ? (
          <GitHubHostedRunners
            fetchRunnersBasePath={fetchRunnersBasePath}
            setUpRunnersLink={setUpRunnersLink}
            state={runnersState as RunnersQueryState<GitHubHostedRunnersResponse> | undefined}
          />
        ) : (
          <SelfHostedRunners
            fetchRunnersBasePath={fetchRunnersBasePath}
            setUpRunnersLink={setUpRunnersLink}
            state={runnersState as RunnersQueryState<SelfHostedRunnersData> | undefined}
          />
        )}
      </div>
    </>
  )
}
